import { render } from "./FeaturedImages.vue?vue&type=template&id=67c76ca7"
import script from "./FeaturedImages.vue?vue&type=script&lang=js"
export * from "./FeaturedImages.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__